import AppLayout from "@/layouts/AppLayout";
import { useUniversityNavLinks } from "@/pages/education/universities/[universityId]/_universityNav";
import { Outlet, useParams } from "react-router-dom";
import InternshipsTabLayout from "./_TabLayout";
import UniversityHeading from "../_layouts/UniversityHeading";
import { useQuery } from "@apollo/client";
import { UNIVERSITY_QUERY } from "../queries";
import { useIsCompactLayout } from "@/hooks/useIsCompactLayout";
import Breadcrumb from "@/components/Breadcrumb";

export default function InternshipsLayout() {
  const { universityId } = useParams();
  const { isCompactLayout } = useIsCompactLayout();

  const { data: universityData } = useQuery(UNIVERSITY_QUERY, {
    variables: { legacyId: universityId },
    skip: !universityId,
    errorPolicy: "all"
  });

  const university = universityData?.universities[0];

  const navLinks = useUniversityNavLinks(universityId!);

  const renderDesktopLayout = () => (
    <>
      <UniversityHeading
        universityName={university?.name || ""}
        logoUrl={university?.logoUrl}
        activeStudentCount={university?.activeStudentCount}
        alumniStudentCount={university?.alumniStudentCount}
        studentProgramSummary={university?.studentProgramSummary}
      />
      <InternshipsTabLayout>
        <Outlet />
      </InternshipsTabLayout>
    </>
  );

  const renderMobileLayout = () => (
    <>
      <Breadcrumb
        compactOnly
        compactTitle="Internships"
        backLink={{ to: "/education/universities/:universityId", params: { universityId: universityId! } }}
      />
      <UniversityHeading
        universityName={university?.name || ""}
        logoUrl={university?.logoUrl}
        activeStudentCount={university?.activeStudentCount}
        alumniStudentCount={university?.alumniStudentCount}
        studentProgramSummary={university?.studentProgramSummary}
      />
      <InternshipsTabLayout>
        <Outlet />
      </InternshipsTabLayout>
    </>
  );

  return (
    <AppLayout navLinks={navLinks} interior bottomBar>
      {isCompactLayout ? renderMobileLayout() : renderDesktopLayout()}
    </AppLayout>
  );
}
